import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import _ from "lodash";
import * as React from "react";

/* toBlob polyfill */
if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
        value(callback, type, quality) {
            const binStr = atob(this.toDataURL(type, quality).split(",")[1]);
            const len = binStr.length;
            const arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                arr[i] = binStr.charCodeAt(i);
            }
            callback(new Blob([arr], { type: type || "image/png" }));
        },
    });
}

const defaultImageSmoothingQuality = "high";

export class Crop extends React.Component<{
    aspectRatio: number,
    controls?: boolean,
    crop: boolean,
    image: string,
    maxHeight?: number,
    maxWidth?: number,
    onCrop: (blob: Blob, transform: any) => void,
    onReady?: () => void,
    transform?: any,
}, { cropWidth: number | null, cropHeight: number | null }> {
    public state = {
        cropHeight: 0,
        cropWidth: 0,
    };

    private image: HTMLImageElement;
    private cropper: Cropper;
    private _mounted: boolean;

    private crop = _.throttle(() => {
        this.cropper.getCroppedCanvas({
            imageSmoothingQuality: defaultImageSmoothingQuality,
        } as any).toBlob((blob) => {
            this.props.onCrop(blob, {
                canvasData: this.cropper.getCanvasData(),
                cropBoxData: this.cropper.getCropBoxData(),
                data: this.cropper.getData(),
            });
        }, "image/jpeg");
    }, 1000);

    public componentDidMount() {
        this._mounted = true;
        this.cropper = new Cropper(this.image, {
            aspectRatio: this.props.aspectRatio,
            crop: (e) => {
                if (!this._mounted) {
                    return;
                }
                this.setState({
                    cropHeight: Math.ceil(e.detail.height),
                    cropWidth: Math.ceil(e.detail.width),
                });
            },
            cropBoxResizable: false,
            guides: false,
            imageSmoothingQuality: defaultImageSmoothingQuality,
            ready: () => {
                if (this.props.transform) {
                    this.cropper.setData(this.props.transform.data);
                    this.cropper.setCanvasData(this.props.transform.canvasData);
                    this.cropper.setCropBoxData(this.props.transform.cropBoxData);
                }
                if (this.props.onReady) {
                    this.props.onReady();
                }
            },
            viewMode: 1,
        } as any);
    }

    public componentWillUnmount() {
        this._mounted = false;
    }

    public componentDidUpdate() {
        if (this.props.crop === true) {
            this.crop();
        }
    }

    public render() {
        return (
            <div>
                <div><img src={this.props.image} style={{ maxWidth: "100%" }} ref={(ref) => this.image = ref} crossOrigin="anonymous" /></div>
                {this.props.controls ? <div style={{ marginTop: "5px" }}>
                    <label htmlFor="width">W:</label>&nbsp;
                    <input
                        type="number"
                        name="width"
                        value={this.state.cropWidth || ""}
                        min={0}
                        onChange={(e) => this.setState({ cropWidth: parseInt(e.target.value, 10) })}
                        onBlur={(e) => this.setCropBox({ width: this.state.cropWidth })}
                    />&nbsp;
                    <label htmlFor="height">H:</label>&nbsp;
                    <input
                        type="number"
                        name="height"
                        value={this.state.cropHeight || ""}
                        min={0}
                        onChange={(e) => this.setState({ cropHeight: parseInt(e.target.value, 10) })}
                        onBlur={(e) => this.setCropBox({ height: this.state.cropHeight })}
                    />
                </div> : null}
            </div>
        );
    }

    private setCropBox(cropBox: { width?: number, height?: number }) {
        const data = this.cropper.getData();
        if (cropBox.width) {
            data.width = cropBox.width;
        }
        if (cropBox.height) {
            data.height = cropBox.height;
        }
        this.cropper.setData(data);
    }
}
